export default __webpack_public_path__ + "static/media/timeWarning.7cc3183e.svg";